<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">帮扶中心众筹招股四件套档案</div>

    <!-- 须知 -->
    <div class="sub">
      <div>
        <span>四件套档案说明</span>
        <div class="msg">
          <span>帮扶实战方案 + 实战票 + 承诺签名手持照 + 合同签名照</span>
          <span>投注站按众筹招股上传，一次招股一份，按投注站 / 期号归档留痕</span>
        </div>
      </div>
    </div>

    <!-- 筛选区（按真实 PO 查询条件设计，后端无彩种/期类型筛选） -->
    <div class="filter-bar">
      <el-input v-model="query.bettingShopNumber" placeholder="投注站编号" clearable size="small" class="f-item" @keyup.enter.native="onSearch" />
      <el-input v-model="query.phoneNumber" placeholder="手机号" clearable size="small" class="f-item" @keyup.enter.native="onSearch" />
      <el-input v-model="query.issueNumber" placeholder="期号" clearable size="small" class="f-item" @keyup.enter.native="onSearch" />
      <el-date-picker v-model="dateRange" type="daterange" size="small" class="f-item"
        range-separator="至" start-placeholder="上传开始" end-placeholder="上传结束"
        value-format="yyyy-MM-dd" @change="onDateChange" />
      <el-button type="primary" size="small" @click="onSearch">查询</el-button>
      <el-button size="small" @click="onReset">重置</el-button>
    </div>

    <el-table :data="list" v-loading="loading" empty-text="暂无合同档案"
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column prop="bettingShopNumber" label="投注站编号" width="120" show-overflow-tooltip />
      <el-table-column prop="bettingShop" label="投注站地址" show-overflow-tooltip />
      <el-table-column prop="nickname" label="负责人昵称" width="110" show-overflow-tooltip />
      <el-table-column prop="identityCardName" label="真实姓名" width="100" show-overflow-tooltip />
      <el-table-column prop="phoneNumber" label="手机号" width="130" />
      <el-table-column prop="issueNumber" label="期号" width="110" />
      <el-table-column prop="createTime" label="上传时间" width="170" />
      <el-table-column label="四件套" width="90" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="fenye">
      <span class="zhanwei"></span>
      <el-pagination v-if="total > 0" background layout="prev, pager, next" :total="total"
        :page-size="pageSize" :current-page="pageNum" @current-change="onPage" />
      <span class="zhanwei"></span>
    </div>

    <!-- 四件套详情弹窗 -->
    <el-dialog title="帮扶四件套" :visible.sync="detailVisible" width="640px" @close="current = null">
      <div v-if="current" class="contract-detail">
        <div class="cd-line"><span>投注站</span><b>{{ current.bettingShop || '-' }}（{{ current.bettingShopNumber || '-' }}）</b></div>
        <div class="cd-line"><span>负责人</span><b>{{ current.nickname || '-' }} / {{ current.identityCardName || '-' }} / {{ current.phoneNumber || '-' }}</b></div>
        <div class="cd-line"><span>期号</span><b>{{ current.issueNumber || '-' }}</b></div>
        <div class="cd-block">
          <div class="cd-label">帮扶实战方案</div>
          <a v-if="isUrl(current.practicalSchemes)" :href="$img(current.practicalSchemes)" target="_blank" class="cd-link">下载方案文件</a>
          <div v-else class="cd-text">{{ current.practicalSchemes || '未上传' }}</div>
        </div>
        <div class="cd-block">
          <div class="cd-label">实战票</div>
          <img v-if="current.practicalTicket" :src="$img(current.practicalTicket)" class="cd-img" alt="实战票" />
          <span v-else class="cd-empty">未上传</span>
        </div>
        <div class="cd-block">
          <div class="cd-label">承诺签名手持照</div>
          <img v-if="current.signature" :src="$img(current.signature)" class="cd-img" alt="签名照" />
          <span v-else class="cd-empty">未上传</span>
        </div>
        <div class="cd-block">
          <div class="cd-label">合同签名照</div>
          <img v-if="current.contractSignature" :src="$img(current.contractSignature)" class="cd-img" alt="合同照" />
          <span v-else class="cd-empty">未上传</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { contractArchiveList } from '@/api/apply'

export default {
  data() {
    return {
      query: { bettingShopNumber: '', phoneNumber: '', issueNumber: '', startTime: '', endTime: '' },
      dateRange: [],
      list: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      loading: false,
      detailVisible: false,
      current: null,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push('/sttzzbfzx')
    },
    onDateChange(val) {
      if (val && val.length === 2) {
        this.query.startTime = val[0] + ' 00:00:00'
        this.query.endTime = val[1] + ' 23:59:59'
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
    onSearch() {
      this.pageNum = 1
      this.loadData()
    },
    onReset() {
      this.query = { bettingShopNumber: '', phoneNumber: '', issueNumber: '', startTime: '', endTime: '' }
      this.dateRange = []
      this.pageNum = 1
      this.loadData()
    },
    onPage(page) {
      this.pageNum = page
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = { ...this.query, pageNum: this.pageNum, pageSize: this.pageSize }
      contractArchiveList(params).then(res => {
        this.list = (res && res.rows) || []
        this.total = (res && res.total) || 0
      }).catch(() => {
        this.list = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    openDetail(row) {
      this.current = row
      this.detailVisible = true
    },
    isUrl(v) {
      if (!v) return false
      return /^(https?:)?\//.test(v) || v.indexOf('.') > -1
    },
  }
}
</script>

<style lang="scss" scoped>
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5faff 0%, #eaf2fa 100%);
  margin-top: 14px;

  .f-item {
    width: 180px;
  }
}

.sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5faff 0%, #eaf2fa 100%);
  margin-top: 14px;
  position: relative;

  >div {
    flex: 1;

    >span {
      display: inline-block;
      color: #347caf;
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 8px;
    }
  }

  .msg {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 24px;
    margin-top: 6px;

    span {
      color: #e67e22;
      font-size: 13px;
      position: relative;
      padding-left: 14px;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #e67e22;
      }
    }
  }
}

.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .zhanwei {
    width: 25%;
  }
}

.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
    position: absolute;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}

.contract-detail {
  .cd-line {
    display: flex;
    padding: 6px 0;
    border-bottom: 1px dashed #e4e7ed;

    span {
      width: 80px;
      color: #888;
      flex: 0 0 auto;
    }

    b {
      color: #333;
      font-weight: 500;
    }
  }

  .cd-block {
    margin-top: 14px;

    .cd-label {
      color: #347caf;
      font-weight: bold;
      margin-bottom: 6px;
    }

    .cd-text {
      white-space: pre-wrap;
      color: #333;
      background: #f7f9fc;
      border-radius: 6px;
      padding: 10px;
    }

    .cd-link {
      color: #347caf;
    }

    .cd-img {
      max-width: 100%;
      border: 1px solid #e4e7ed;
      border-radius: 6px;
    }

    .cd-empty {
      color: #999;
    }
  }
}

::v-deep .el-table th {
  background-color: #eef4ff;
  color: #1565d8;
  font-weight: bold;

  .cell {
    text-align: center;
  }
}

::v-deep .el-table td,
::v-deep .el-table th.is-leaf {
  border-bottom: 1px solid rgba(21, 101, 216, 0.12);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f9ff;
}
</style>
